// src/lib/profile.js
import { supabase } from "../../supabaseClient";

const COLUMNS =
  "id, full_name, email, mobile_number, username, province, created_at";

export async function getOrCreateUserProfile() {
  const { data: sessionData, error: sessErr } = await supabase.auth.getSession();
  if (sessErr) throw sessErr;
  const session = sessionData?.session;
  if (!session) throw new Error("No session (user not authenticated yet).");

  const uid = session.user.id;

  // Try fetch first (safe on 0 rows)
  const { data: row, error: selErr } = await supabase
    .from("user")
    .select(COLUMNS)
    .eq("id", uid)
    .maybeSingle();
  if (selErr) throw selErr;
  if (row) return row;

  // Seed payload — MUST match auth.uid()
  const payload = {
    id: uid,
    email: session.user.email ?? "",
    full_name: session.user.user_metadata?.full_name ?? "",
    username: session.user.user_metadata?.user_name ?? "",
    mobile_number: "",
    province: "",
  };

  console.log("[profile] upsert payload", { uid, payload });

  // UPSERT is race-safe; onConflict PK=id
  const { data: inserted, error: upErr } = await supabase
    .from("user")
    .upsert(payload, { onConflict: "id" })
    .select(COLUMNS)
    .single();

  if (upErr) {
    console.error("[profile] upsert error", upErr);
    throw upErr;
  }
  return inserted;
}

export async function updateUserProfile(patch) {
  const { data: sessionData, error: sessErr } = await supabase.auth.getSession();
  if (sessErr) throw sessErr;
  const uid = sessionData?.session?.user?.id;
  if (!uid) throw new Error("No session.");

  const { data, error } = await supabase
    .from("user")
    .update(patch)
    .eq("id", uid)
    .select(COLUMNS)
    .single();

  if (error) throw error;
  return data;
}
